<template>
  <div class="new-version-banner" v-if="newVersion">
    <span>{{ $t('dash.header.nav.new_front_version') }}{{ newVersion }}</span>
    <button type="button" class="new-version-banner-reload" @click="reloadApp">{{ $t('dash.header.nav.reload_now') }}</button>
  </div>
</template>

<script>
import Notif from '../mixins/Notif'
import { EventBus } from '@/event-bus'
import { isNewerVersion } from '@/utils/appVersion'
import { version } from './../../../package.json'

export default {
  name: 'new-version-banner',

  mixins: [Notif],

  data() {
    return {
      applicationVersionDB: localStorage.getItem('front_version')
    }
  },

  computed: {
    newVersion() {
      return this.applicationVersionDB && isNewerVersion(this.applicationVersionDB, version) ? this.applicationVersionDB : null
    }
  },

  mounted() {
    // Mounted in Dash.vue (not Header) so it also shows on routes without header, e.g. postCreator
    this.updateFrontVersionDB()
    this.frontVersionCheckInterval = setInterval(this.updateFrontVersionDB, 5 * 60 * 1000)
  },

  beforeDestroy() {
    clearInterval(this.frontVersionCheckInterval)
  },

  methods: {
    updateFrontVersionDB() {
      this.getFrontVersion().then(res => {
        if (!res || !res.body || res.body.success !== true) return
        localStorage.setItem('front_version', res.body.front_version)
        this.applicationVersionDB = res.body.front_version
      })
    },

    reloadApp() {
      // Keep the post in progress: autosave now, auto-restore after reload (PostCreator.vue's mounted())
      if (this.$route.name === 'postCreator') {
        EventBus.$emit('postcreator/forceSaveDraftBeforeReload')
        sessionStorage.setItem('mashup_reload_restore_draft', '1')
      }
      location.reload()
    }
  }
}
</script>

<style scoped>
.new-version-banner {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 10px 20px;
  background: #6a1f4c;
  color: #fff;
  font-size: 14px;
}

.new-version-banner-reload {
  border: 1px solid #fff;
  background: transparent;
  color: #fff;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}

.new-version-banner-reload:hover {
  background: #fff;
  color: #6a1f4c;
}
</style>
